import { deliveryNote as deliveryNoteEn } from '../en/deliveryNote';

export const deliveryNote = {
  ...deliveryNoteEn,
  deliveryNotes: 'டெலிவரி குறிப்புகள்',
  allDeliveryNotes: 'அனைத்து டெலிவரி குறிப்புகள்',
  createDeliveryNote: 'டெலிவரி குறிப்பை உருவாக்கு',
  deliveryNoteDetails: 'டெலிவரி குறிப்பு விவரங்கள்',
  status_pending: 'நிலுவையில்',
  status_delivered: 'வழங்கப்பட்டது',
  status_cancelled: 'ரத்து செய்யப்பட்டது',
  officialDeliveryNote: 'அதிகாரப்பூர்வ விநியோக குறிப்பு',
  shop: 'கடை',
  allShops: 'அனைத்து கடைகள்',
  orderNotFound: 'ஆர்டர் கிடைக்கவில்லை',
  remainingQty: 'மீதமுள்ள அளவு',
};
